module.exports = __webpack_public_path__ + "static/media/Education_Payments_Solution_by_Safexpay.81698bad.pdf";